import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createTenant } from "api/tenants";

import { TenantPerson } from "js/components/types";

import { queryKeys } from "./queryKeys";

export const useCreateTenant = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createTenant,
    onSuccess: (data: TenantPerson) => {
      const legalTypeCode = String(data.legal_type);
      const transformedData = {
        ...data,
        legal_type:
          legalTypeCode === "1"
            ? "Natural"
            : legalTypeCode === "2"
              ? "Legal"
              : data.legal_type,
      };

      queryClient.setQueryData(
        queryKeys.tenants.all,
        (oldData: TenantPerson[] | undefined) => {
          if (!oldData) return [transformedData];
          return [transformedData, ...oldData];
        },
      );

      queryClient.invalidateQueries({ queryKey: queryKeys.tenants.all });
      queryClient.invalidateQueries({ queryKey: queryKeys.tenants.lists() });
      queryClient.invalidateQueries({
        queryKey: queryKeys.tenants.organization(),
      });
    },
  });
};
